import { useCallback, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { fetchWrapper } from '../../../../helpers';
import { API_ENDPOINT } from '../../../../constants';

import type { ChangeProviderEmailResult } from './types';

export const useChangeProviderEmail = (): ChangeProviderEmailResult => {
  const { getAccessTokenSilently } = useAuth0();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const reset = useCallback(() => {
    setLoading(false);
    setError(null);
    setSuccess(false);
  }, []);

  const changeEmail = async (providerId: number, newEmail: string) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await fetchWrapper.put(
        { url: `${API_ENDPOINT}/providers/${providerId}/email/`, getAccessTokenSilently },
        { email: newEmail },
      );
      setSuccess(true);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to change provider email');
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, success, changeEmail, reset };
};
